import { metrics } from '@opentelemetry/api'
import { CLSMetric, INPMetric, LCPMetric, onCLS, onINP, onLCP } from 'web-vitals'

import { INSTRUMENTATION_NAME } from '../constants'
import { normalizePathname } from './utils/normalizePathname'

/**
 * Set up meaningful distributions aligned with the Core Web Vitals thresholds,
 * rather than the default histogram boundaries optimized for HTTP latency.
 */
const LCP_BUCKET_BOUNDARIES = [500, 1000, 1500, 2500, 3000, 3500, 4000, 5000, 7000]
const INP_BUCKET_BOUNDARIES = [50, 100, 200, 300, 400, 500, 600, 800]
const CLS_BUCKET_BOUNDARIES = [0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.5]

export const trackWebVitals = () => {
    const meter = metrics.getMeter(INSTRUMENTATION_NAME)

    const lcp = meter.createHistogram('app.web_vitals.lcp', {
        description: 'Largest Contentful Paint',
        advice: { explicitBucketBoundaries: LCP_BUCKET_BOUNDARIES },
        unit: 'ms',
    })
    const inp = meter.createHistogram('app.web_vitals.inp', {
        description: 'Interaction to Next Paint',
        advice: { explicitBucketBoundaries: INP_BUCKET_BOUNDARIES },
        unit: 'ms',
    })
    const cls = meter.createHistogram('app.web_vitals.cls', {
        description: 'Cumulative Layout Shift',
        advice: { explicitBucketBoundaries: CLS_BUCKET_BOUNDARIES },
        // CLS is a unitless score
    })

    const getMetricAttributes = (metric: LCPMetric | INPMetric | CLSMetric) => ({
        rating: metric.rating,
        'di.url.path': normalizePathname(window.location.pathname),
        // `navigationType` is usually helpful to segment caching effects, but doesn't work with a SPA
    })

    onLCP(metric => lcp.record(metric.value, getMetricAttributes(metric)))
    onINP(metric => inp.record(metric.value, getMetricAttributes(metric)))
    onCLS(metric => cls.record(metric.value, getMetricAttributes(metric)))
}
